<script lang="ts">
import Pill from "../components/Pill.svelte";
import Word from '~icons/mdi/file-word-box';

type Props = {
  numWords: number;
}
const { numWords }: Props = $props();
</script>

<Pill
  value={numWords}
  class=green
>
  <Word size={24} />
</Pill>
